export enum DeviceType {
  EBS = 'EBS',

  ABS = 'ABS',

  MCD = 'MCD',

  MIO = 'MIO',

  TDI = 'TDI',

  RFID = 'RFID',

  VIRTUAL = 'VIRTUAL',

  INCLINOMETER = 'INCLINOMETER',

  LINING = 'LINING',

  RODOCAL = 'RODOCAL',

  ST310U = 'ST310U',

  TPMS = 'TPMS',

  ST340UR = 'ST340UR',

  XG4780 = 'XG4780',

  ST4315 = 'ST4315',

  ST4305 = 'ST4305',

  ST8310 = 'ST8310',

  EFMA = 'EFMA',

  TELTONIKA = 'TELTONIKA',
}
